import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useRef, useCallback, useContext, } from 'react';
import { Outlet } from 'react-router-dom';
const DEFAULT_DURATION = 10000;
const SnackbarContext = createContext({
    messages: new Map(),
    hideSnackbar: () => { },
    showError: () => { },
    showInfo: () => { },
    showWarning: () => { },
    showSuccess: () => { },
});
// eslint-disable-next-line react-refresh/only-export-components
export const useSnackbar = () => useContext(SnackbarContext);
export const SnackbarProvider = () => {
    const uid = useRef(0);
    const [messages, setMessages] = useState(new Map());
    const hideSnackbar = useCallback((id) => {
        setMessages(prevState => {
            const stateCopy = new Map(prevState);
            stateCopy.delete(id);
            return stateCopy;
        });
    }, []);
    const addMessage = useCallback((message, severity, duration = DEFAULT_DURATION, parameters = {}) => {
        const id = ++uid.current;
        setMessages(prevState => {
            return new Map(prevState).set(id, {
                id,
                message,
                parameters,
                severity,
                duration,
            });
        });
        setTimeout(() => hideSnackbar(id), duration);
    }, [hideSnackbar]);
    const showSuccess = useCallback((message, duration) => {
        addMessage(message, 'success', duration);
    }, [addMessage]);
    const showError = useCallback((message, duration) => {
        const [error, params] = Array.isArray(message) ? message : [message];
        addMessage(error, 'error', duration, params);
    }, [addMessage]);
    const showWarning = useCallback((message, duration) => {
        addMessage(message, 'warning', duration);
    }, [addMessage]);
    const showInfo = useCallback((message, duration) => {
        addMessage(message, 'info', duration);
    }, [addMessage]);
    return (_jsx(SnackbarContext.Provider, { value: {
            showSuccess,
            showError,
            showWarning,
            showInfo,
            hideSnackbar,
            messages,
        }, children: _jsx(Outlet, {}) }));
};
